import React from "react";
import { FilterMatchMode } from "primereact/api";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { ColumnConfig } from "../../../components/ReusableList";
import {
  NOT_EXCLUDED_LABEL,
  VAT_ID_EXCLUSION_REASONS,
} from "../../../utils/vatIdExclusion";

/** Row field CustomerList derives from `vat_id_exclusion` (CLR-273). */
export const VAT_ID_EXCLUSION_STATUS_FIELD = "vat_id_exclusion_status";

// The column holds the label, so the filter matches on the label too.
const exclusionStatusOptions = [
  NOT_EXCLUDED_LABEL,
  ...VAT_ID_EXCLUSION_REASONS.map((r) => r.label),
].map((label) => ({ label, value: label }));

const exclusionStatusFilter = (options: ColumnFilterElementTemplateOptions) => (
  <Dropdown
    value={options.value}
    options={exclusionStatusOptions}
    optionLabel="label"
    optionValue="value"
    onChange={(e) => options.filterCallback(e.value, options.index)}
    placeholder="Any"
    showClear
    className="w-full"
  />
);

export const availableColumns: ColumnConfig[] = [
    {
        label: "Recipient Name",
        value: "address.recipient_name",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Company Name",
        value: "address.company_name",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "IBAN",
        value: "iban",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Email",
        value: "email",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "City",
        value: "address.city",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Country",
        value: "address.country",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Phone",
        value: "phone",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Industry",
        value: "industry",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Account Holder",
        value: "account_holder_name",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Street Address",
        value: "address.street_address",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Postal Code",
        value: "address.postal_code",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "BIC",
        value: "bic",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "VAT ID",
        value: "vat_id",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "Business Type",
        value: "business_type",
        sortable: true,
        style: { width: "20%" },
    },
    {
        label: "VAT ID Exclusion",
        value: VAT_ID_EXCLUSION_STATUS_FIELD,
        sortable: true,
        filter: true,
        filterElement: exclusionStatusFilter,
        filterMatchMode: FilterMatchMode.EQUALS,
        showFilterMatchModes: false,
        showFilterOperator: false,
        showAddButton: false,
        style: { width: "20%" },
    },
];

export const defaultColumnValues = [
    "address.recipient_name",
    "address.company_name",
    "business_type",
    "vat_id",
    VAT_ID_EXCLUSION_STATUS_FIELD,
];
